module.exports = __webpack_public_path__ + "static/media/xmg-group.d74c0a1d.png";